import React, { memo } from 'react';
import classnames from 'classnames';
import Element from 'src/components/base/element';
import { PREFIX } from 'src/constants';
interface IProps {
    className?: string;
    children: React.ReactNode;
}

function NavbarBrand(props: IProps) {
    const { children, className, ...rest } = props;

    return (
        <Element
            {...rest}
            className={classnames(`${PREFIX}-navbar-brand`, className)}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarBrand);
